<div class="container-lg bg-white cornerr mt-5">

    <div class="row" style="margin-top: 100px;">

        <div class="col-12">
            <div class="d-flex justify-content-center">
                <div class="col-12">
                    <a routerLink="/propuestas">
                        <img src="https://nld.gob.mx/assets/logos/bannerPrincipal3.jpg" class="d-block w-100 rounded"
                            alt="...">
                    </a>

                </div>

            </div>

        </div>

    </div>
</div>
<div class="container bg-white">
    <div class="row">
        <div class="col-md-12 my-5" >
           
          
                <div class="row mt-5">
                    <div class="col-12">
                        <small>Click en los siguientes enlaces</small>
                    </div>
                    <div class="d-flex justify-content-center  mt-5" >
                        
                        <button  class="boo btn-lg d-block d-md-none" type="button" (click)="opcion1()">INSCRÍBETE A LOS FOROS DE CONSULTA POPULAR</button>

                        <h3 class="d-none d-md-block">
                    
                            <a class="btn-prepa rounded" (click)="opcion1()"
                                style="text-decoration: none;text-align: center; max-height: 50px;cursor: pointer;">
                    
                    
                                 INSCRÍBETE A LOS FOROS DE CONSULTA POPULAR
                            </a>
                    
                        </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="d-flex justify-content-center mt-5">
                        <button  class="boo btn-lg d-block d-md-none" type="button" (click)="opcion2()">ENVÍA TU PROPUESTA AL GOBIERNO DE NUEVO LAREDO</button>
                        <h3 class="d-none d-md-block">
                            
                            
                            <a class="btn-prepa rounded" (click)="opcion2()"
                                style="text-decoration: none; text-align: center; max-height: 50px;cursor: pointer;">
                
                  
                                ENVÍA TU PROPUESTA AL GOBIERNO DE NUEVO LAREDO
                            </a>
                
                        </h3>
                    </div>
                </div>

                <div class="row mt-5" >
                    <div class="col-12">
                        <div class="d-flex justify-content-center mt-5">
                        <div class="row" *ngIf="op1">
                            <div class="col-12">
                                <div class="d-flex justify-content-center">
                                    <div class="col-12">
                                        <h2  class="block-title colorSecundario">¡INSCRÍBETE!</h2>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                       
                        <!--
                        <small>Selecciona el cuadro del foro en el cual quieres participar</small>-->
                        <div class="row" *ngIf="op2">
                            <div class="col-12">
                            <h2 class="block-title colorSecundario">ENVÍA TU PROPUESTA AL GOBIERNO DE NUEVO LAREDO</h2>
                          
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="op2 || op1">
                <div class="row">
                    <div class="row">
                        <div class="col-12">
                            <small>Selecciona el cuadro del foro en el cual quieres participar</small>
                        </div>
                    </div>
                    <div class="col-12 col-md-4"  style="cursor:pointer;">
                        <div class="card" style="padding: 0 0 0 0px;">
                            <div class="card-header" style="background-color: #cc9f52;color: white;font-size: x-large;">
                                Desarrollo humano
                            </div>
                            <div class="card-body" style="background-color: #931939;color: white;">
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo humano','Educación')">Educación</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo humano','Arte y cultura')">Arte y cultura</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo humano','Cultura física y práctica del deporte')">Cultura física y práctica del deporte</h6>
                    
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4"  style="cursor:pointer;">
                        <div class="card" style="padding: 0 0 0 0px;">
                            <div class="card-header" style="background-color: #cc9f52;color: white;font-size: x-large;">
                            Paz y convivencia ciudadana
                            </div>
                            <div class="card-body" style="background-color: #931939;color: white;">
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Paz y convivencia ciudadana','Protección civil')">Protección civil</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Paz y convivencia ciudadana','Seguridad vial')">Seguridad vial</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Paz y convivencia ciudadana','Paz y orden')">Paz y orden</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Paz y convivencia ciudadana','Cuidado y respeto animal')">Cuidado y respeto animal</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4"  style="cursor:pointer;">
                        <div class="card" style="padding: 0 0 0 0px;">
                            <div class="card-header" style="background-color: #cc9f52;color: white;font-size: x-large;">
                            Bienestar y familia
                            </div>
                            <div class="card-body" style="background-color: #931939;color: white;">
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derechos de las mujeres')">Derechos de las mujeres</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derechos de las niñas, niños y adolescentes')">Derechos de las niñas, niños y adolescentes</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derechos de las personas con discapacidad')">Derechos de las personas con discapacidad</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derechos de los adultos mayores')">Derechos de los adultos mayores</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derechos de los jóvenes')">Derechos de los jóvenes</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derecho a la salud oportuna y de calidad')">Derecho a la salud oportuna y de calidad</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derecho a la salud emocional y mental')">Derecho a la salud emocional y mental</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derecho a la alimentación saludable y nutritiva')">Derecho a la alimentación saludable y nutritiva</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Inclusión y respeto a la población LGBTIQ+')">Inclusión y respeto a la población LGBTIQ+</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Bienestar y familia','Derechos de los migrantes')">Derechos de los migrantes</h6>
                            </div>
                        </div>
                    </div>
                   
                  
                </div>
                <div class="row">
                
                    <div class="col-12 col-md-4"   style="cursor:pointer;">
                        <div class="card" style="padding: 0 0 0 0px;">
                            <div class="card-header" style="background-color: #cc9f52;color: white;font-size:20px;">
                            Desarrollo Económico con prosperidad para todos
                            </div>
                            <div class="card-body" style="background-color: #931939;color: white;">
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo Económico con prosperidad para todos','Industria')">Industria</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo Económico con prosperidad para todos','Impulso al fomento y comercio local')">Impulso al fomento y comercio local</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo Económico con prosperidad para todos','Empresas de servicio y comercio exterior')">Empresas de servicio y comercio exterior</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo Económico con prosperidad para todos','Turismo')">Turismo</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo Económico con prosperidad para todos','Desarrollo rural')">Desarrollo rural</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Desarrollo Económico con prosperidad para todos','Competitividad')">Competitividad</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4"  style="cursor:pointer;">
                        <div class="card" style="padding: 0 0 0 0px;">
                            <div class="card-header" style="background-color: #cc9f52;color: white;font-size:22px;">
                                Gobierno eficiente y de resultados
                            </div>
                            <div class="card-body" style="background-color: #931939;color: white;">
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Gobierno humanista')">Gobierno humanista</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Desarrollo administrativo y tecnológico')">Desarrollo administrativo y tecnológico</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Finanzas sanas')">Finanzas sanas</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Transparencia y rendición de cuentas')">Transparencia y rendición de cuentas</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Combate a la corrupción')">Combate a la corrupción</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Planeación y evaluación gubernamental')">Planeación y evaluación gubernamental</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Gobierno eficiente y de resultados','Liderazgo binacional')">Liderazgo binacional</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4"  style="cursor:pointer;">
                        <div class="card" style="padding: 0 0 0 0px;">
                            <div class="card-header" style="background-color: #cc9f52;color: white;font-size: x-large;">
                                Transformación de la ciudad
                            </div>
                            <div class="card-body" style="background-color: #931939;color: white;">
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Obras públicas para el desarrollo social y económico')">Obras públicas para el desarrollo social y económico</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Movilidad urbana')">Movilidad urbana</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Vivienda digna')">Vivienda digna</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Agua potable para toda la ciudadanía')">Agua potable para toda la ciudadanía</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Servicios Públicos')">Servicios Públicos</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Planeación Urbana')">Planeación Urbana</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Protección al medio ambiente')">Protección al medio ambiente</h6>
                                <h6 class="card-title" style="color: white;" (click)="opcionSelectTema2('Transformación de la ciudad','Conectividad digital')">Conectividad digital</h6>
                                
                            </div>
                        </div>
                    </div>
                
                
                </div>
                </div>
                <!--ngIf="captura"-->
                <div  class="row mt-5 pt-5"  id="captura" *ngIf="captura">
                    <div class="row">
                        <div class="col-12" *ngIf="op1">
                          
                            <div class="d-flex justify-content-center  mt-5">
                            <h3>El Foro de Consulta Popular con el tema de {{tema2}} se realizarà el miércoles 11 de diciembre de 2024, a las {{hora}} horas,
                                en las instalaciones de Estación Palabra, ubicadas en Avenida César López de Lara, 1020, Centro, 88000, Nuevo Laredo, Tamaulipas.
                            </h3>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="op2">
                           
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center  mt-5">
                                            <h3 style="color: #cc9f52;">ENVIA TU PROPUESTA AL GOBIERNO D NUEVO LAREDO
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-center  mt-5">
                                    <h3>Tema: {{tema2}}
                                    </h3>
                                    
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-center  mt-5">
                                        <h3>Subtema: {{subtema2}}
                                        </h3>
                            
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-center  mt-5">
                                  
                                        <small>COMPLETA EL SIGUIENTE FORMULARIO Y ADJUNTA TU PROPUESTA EN FORMATO DE WORD (.DOC)</small>
                                    </div>
                                </div>
                            </div>
                          
                          
                           
                        </div>
                    </div>
                    <!--
                    <div class="row">
                        <div class="col-md-3"></div>
                        <div class="col-12 col-md-7">

                            <h4>PLAN MUNICIPAL DE DESARROLLO 2024 - 2027</h4>
                            <br>
                            <h5>Nombre del evento: FOROS DE CONSULTA POPULAR</h5>
                            <h5>Número de foros: 2</h5>
                            <h5>Fecha: Miércoles 11 de diciembre de 2024</h5>
                            <h5>Lugar: Estación Palabra</h5>
                            <small>Av César López de Lara 1020, Centro, 88000 Nuevo Laredo, Tamps.</small>
                            <br>
                            <br>
                            <br>
                            <h3 style="color: #cc9f52;">Foro 1</h3>
                            <h5>Horario: 09:00 hrs</h5>
                            <br>
                          
                            <h5><strong>Temas:</strong></h5>
                            
                            
                            <ul>
                                <li><h5>Desarrollo humano</h5></li>
                                <li>
                                    <h5>Paz y convivencia ciudadana</h5>
                                </li>
                                <li>
                                    <h5>Bienestar y familia</h5>
                                </li>
                               
                            </ul>

                            <br>
                            <br>
                            <br>

                            <h3 style="color: #cc9f52;">Foro 2</h3>
                            <h5>Horario: 13:00 hrs</h5>
                            <br>
                            <h5><strong>Temas:</strong></h5>
                            
                            
                            <ul>
                                <li>
                                    <h5>Desarrollo Económico con prosperidad para todos</h5>
                                </li>
                                <li>
                                    <h5>Gobierno eficiente y de resultados</h5>
                                </li>
                                <li>
                                    <h5>Transformación de la ciudad</h5>
                                </li>
                            
                            </ul>
                     
                        </div>
                      
                    </div>
                -->
                    <div class="col-md-3 mt-5"></div>
                    <div class="col-12 col-md-5">
                        
                        <div class="mt-5">

                               

                                <div class="row">
                                    <div class="col-12">
                                
                                        <div class="d-flex justify-content-center" >
                                
                                            <div class="col-12 text-left">
                                
                                                <label class="form-label" class="">Tema</label>
                                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                                    class="form-select" aria-label="Seleccione Tema" (change)="opcionSelectTema()" [(ngModel)]="tema" disabled>
                                
                                                    <option value="Desarrollo humano" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Desarrollo humano
                                                    </option>
                                                    <option value="Paz y convivencia ciudadana"
                                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Paz y convivencia ciudadana
                                                    </option>
                                                    <option value="Bienestar y familia"
                                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Bienestar y familia
                                                    </option>
                                
                                                    <option value="Desarrollo Económico con prosperidad para todos"
                                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Desarrollo Económico con prosperidad para todos
                                                    </option>
                                                    <option value="Gobierno eficiente y de resultados"
                                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Gobierno eficiente y de resultados
                                                    </option>
                                                    <option value="Transformación de la ciudad"
                                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Transformación de la ciudad
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center mt-3">
                                
                                            <div class="col-12 text-left">
                                
                                                <label class="form-label" class="">Subtema</label>
                                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                                    class="form-select" aria-label="Seleccione" [(ngModel)]="subtema">
                                
                                                    <option *ngFor="let item of arraySubtema" value="{{item.item}}"
                                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        {{item.item}}
                                                    </option>
                                
                                                </select>
                                            </div>
                                        </div>
                                
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                    <div class="col-12 text-left">
                                        <label class="form-label">Nombre Completo</label>
                                        <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                            [(ngModel)]="nombre">
                                        <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                        favor de especificarlo en la busqueda.</small>-->
                                    </div>
                                    </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Fecha de Nacimiento</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="fechanac">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Teléfono</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="telefono">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Correo electrónico</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="email">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Nivel de escolaridad</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="nivel">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Oficio o profesión</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="oficio">
                                           
                                                                                                                                                                                                                                     
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Labora en el sector público</label>
                                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" class="form-select"
                                                    aria-label="Seleccione Tema"  [(ngModel)]="labora">
                                                
                                                    <option value="Si" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Si
                                                    </option>
                                                    <option value="No" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        No
                                                    </option>
                                                    
                                                </select>
                                                                                                                                                                                                                                     
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Nombre de la dependencia</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="dependencia">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                                                                                                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Labora en el sector privado</label>
                                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                                    class="form-select" aria-label="Seleccione Tema" [(ngModel)]="labora2">
                                
                                                    <option value="Si" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Si
                                                    </option>
                                                    <option value="No" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        No
                                                    </option>
                                
                                                </select>
                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Nombre de la empresa</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="empresa">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                                                                                                                                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Estudia</label>
                                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                                    class="form-select" aria-label="Seleccione Tema" [(ngModel)]="estudia">
                                
                                                    <option value="Si" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Si
                                                    </option>
                                                    <option value="No" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        No
                                                    </option>
                                
                                                </select>
                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Nombre de la institución educativa</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="institucion">
                                                <!--<small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene mas de un nombre,
                                                                                                                                                                                                                                                                                                                                        favor de especificarlo en la busqueda.</small>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Es miembro de una OSC</label>
                                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                                    class="form-select" aria-label="Seleccione Tema" [(ngModel)]="miembroosc">
                                
                                                    <option value="Si" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        Si
                                                    </option>
                                                    <option value="No" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                                        No
                                                    </option>
                                
                                                </select>
                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-12 text-left">
                                                <label class="form-label">Nombre de la OSC</label>
                                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                                    [(ngModel)]="nombreosc">
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="row"  *ngIf="op2">
                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="col-6 text-left">
                                                <input type="file" (change)="upload($event)" accept=".doc, .docx" >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                               
                                <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-center">
                                    <div class="col-12 text-left">


                                    <ngx-recaptcha2 *ngIf="habil" ngModel name="captcha" [siteKey]="siteKey" (success)="handleSuccess($event)" [useGlobalDomain]="false"
                                        (expire)="handleExpire($event)">
                                    </ngx-recaptcha2>
                                    <button *ngIf="captcha" class="btn btn-primary pull-right" type="button" (click)="enviar()"> <span> <i
                                                class="bi bi-search"></i> Enviar</span>
                                    </button>
                                    
                                    </div>
                                    </div>
                                </div>
                                </div>
                                

                              

                              
                        </div>

                      


                    </div>
                   
                </div>
          


               

                <div class="col-md-12">
                <br>
                    <!--
                <ul>
                    <li>
                        <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento Justicia Cívica de Nuevo Laredo, Tamaulipas

                            <a style="color:#a19249"
                                href="https://nld.gob.mx/assets/reglamentos/Anteproyecto de Reglamento Justicia Civica de Nuevo Laredo, tamaulipas/file1.pdf">
                                Abrir pdf</a>
                        </p>
                    </li>
                  
                </ul>
            
                    <br>
                    <ul>
                            <li>
                                <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento para Plazas,
                                    Parques, Jardines y Monumentos de Nuevo Laredo, Tamaulipas
                                    <a style="color:#a19249"
                                        href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20para%20Plazas,%20Parques,%20Jardines%20y%20Monumentos%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                        Abrir pdf</a>
                                </p>
                            </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento para
                                Plazas,
                                Parques, Jardines y Monumentos de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20para%20Plazas,%20Parques,%20Jardines%20y%20Monumentos%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                   
                    </ul>
                    <br>
                    
                    
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento de Mejora Regulatoria de
                                Nuevo
                                Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Mejora%20Regulatoria%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Mejora Regulatoria
                                de Nuevo
                                Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Mejora%20Regulatoria%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento de Planeación de Nuevo
                                Laredo,
                                Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Planeacion%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Planeación de Nuevo
                                Laredo,
                                Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Planeacion%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                      
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento de Protección Civil y
                                Bomberos
                                del Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Proteccion%20Civil%20y%20Bomberos%20del%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Protección Civil y
                                Bomberos
                                del Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Proteccion%20Civil%20y%20Bomberos%20del%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                       
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento de Tránsito y Vialidad
                                para el
                                Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Transito%20y%20Vialidad%20para%20el%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Tránsito y Vialidad
                                para el
                                Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20Transito%20y%20Vialidad%20para%20el%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                       
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento del Rastro Municipal de
                                Nuevo
                                Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20del%20Rastro%20Municipal%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto del Rastro Municipal
                                de Nuevo
                                Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20del%20Rastro%20Municipal%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                      
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento Interno del Consejo
                                Municipal
                                de Mejora Regulatoria de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20Interno%20del%20Consejo%20Municipal%20de%20Mejora%20Regulatoria%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto Interno del Consejo
                                Municipal
                                de Mejora Regulatoria de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20Interno%20del%20Consejo%20Municipal%20de%20Mejora%20Regulatoria%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                       
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento Interior del Republicano
                                Ayuntamiento de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20Interior%20del%20Republicano%20Ayuntamiento%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto Interior del Republicano
                                Ayuntamiento de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20Interior%20del%20Republicano%20Ayuntamiento%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                      
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento Interior de la
                                Secretaría de Desarrollo Económico
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento Interior de la Secretaria de Desarrollo Economico/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto del Reglamento
                                Interior
                                de la Secretaría de Desarrollo Económico
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento Interior de la Secretaria de Desarrollo Economico/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de la Administración
                                Pública
                                de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20la%20Administracion%20Publica%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Reglamento de la Administración
                                Pública
                                de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Reglamento%20de%20la%20Administracion%20Publica%20de%20Nuevo%20Laredo,%20Tamaulipas/file2.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                    <br>
                    <br>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de Bando
                                de Policía y
                                Buen Gobierno de Nuevo Laredo, Tamaulipas<a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20de%20Bando%20de%20Policia%20y%20Buen%20Gobierno%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a></p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de
                                Cambio Climático para el Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20de%20Cambio%20Climatico%20para%20el%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de la
                                Secretaría
                                de Seguridad Pública y Vialidad del Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20de%20la%20Secretaria%20de%20Seguridad%20Publica%20y%20Vialidad%20del%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de los
                                Espectáculos de Box y Lucha Libre Profesional de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20de%20los%20Espectaculos%20de%20Box%20y%20Lucha%20Libre%20Profesional%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p class="" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento para el
                                Establecimiento de Estaciones de Servicio de Hidrocarburos en el Municipio de Nuevo Laredo, Tamaulipas
                                <a style="color:#a19249"
                                    href="https://nld.gob.mx/assets/reglamentos/Anteproyecto%20de%20Reglamento%20para%20el%20Establecimiento%20de%20Estaciones%20de%20Servicio%20de%20Hidrocarburos%20en%20el%20Municipio%20de%20Nuevo%20Laredo,%20Tamaulipas/file1.pdf">
                                    Abrir pdf</a>
                            </p>
                        </li>
                    </ul>
                   
                -->
                </div>
                
                 
            













                <div class="row mt-5" >
                    <div class="col-md-3 text-left"></div>
                    <div class="col-md-6 text-left">
                        <div class="col-12 col-md-12 text-left">
                           <!--
                            <br>
                            <div class="mb-3 text-left">
                                <label class="form-label" >Nombre Completo</label>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                    [(ngModel)]="nombre">
                              
                            </div>
                        -->
                            <div class="mb-3 text-left">
                                <!--
                                <label class="form-label" class="">Reglamento</label>
                                <select class="mb-5" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" class="form-select"
                                    aria-label="Selecciona Opcion de Busqueda" (change)="opcionSelect()" [(ngModel)]="reglamento">
                            
                                    <option value="Anteproyecto de Reglamento Justicia Civica de Nuevo Laredo, tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento Justicia Civica de Nuevo Laredo, tamaulipas</option>
                                       
                                             <option value="Anteproyecto de Reglamento de Bando de Policia y Buen Gobierno de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de Bando de
                                        Policía y Buen Gobierno de Nuevo Laredo, Tamaulipas</option>

                                    <option value="Anteproyecto de Reglamento de Cambio Climatico para el Municipio de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de Cambio
                                        Climático para el Municipio de Nuevo Laredo, Tamaulipas</option>
                                    <option
                                        value="Anteproyecto de Reglamento de la Secretaria de Seguridad Publica y Vialidad del Municipio de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de la Secretaría
                                        de Seguridad Pública y Vialidad del Municipio de Nuevo Laredo, Tamaulipas</option>
                                    <option
                                        value="Anteproyecto de Reglamento de los Espectaculos de Box y Lucha Libre Profesional de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento de los
                                        Espectáculos de Box y Lucha Libre Profesional de Nuevo Laredo, Tamaulipas</option>
                            
                                    <option
                                        value="Anteproyecto de Reglamento para el Establecimiento de Estaciones de Servicio de Hidrocarburos en el Municipio de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento para el
                                        Establecimiento de Estaciones de Servicio de Hidrocarburos en el Municipio de Nuevo Laredo, Tamaulipas
                                    </option>
                                    <option
                                        value="Anteproyecto de Reglamento para Plazas, Parques, Jardines y Monumentos de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Reglamento para Plazas,
                                        Parques, Jardines y Monumentos de Nuevo Laredo, Tamaulipas</option>
                            
                                    <option value="Reglamento de la Administracion Publica de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de la Administración Pública
                                        de Nuevo Laredo, Tamaulipas</option>
                                    <option value="Reglamento de Mejora Regulatoria de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Mejora Regulatoria de Nuevo
                                        Laredo, Tamaulipas</option>
                                    <option value="Reglamento de Planeacion de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Planeación de Nuevo Laredo,
                                        Tamaulipas</option>
                                    <option value="Reglamento de Proteccion Civil y Bomberos del Municipio de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Protección Civil y Bomberos
                                        del Municipio de Nuevo Laredo, Tamaulipas</option>
                            
                                    <option value="Reglamento de Transito y Vialidad para el Municipio de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto de Tránsito y Vialidad para el
                                        Municipio de Nuevo Laredo, Tamaulipas</option>
                                    <option value="Reglamento del Rastro Municipal de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto del Rastro Municipal de Nuevo
                                        Laredo, Tamaulipas</option>
                                    <option value="Reglamento Interno del Consejo Municipal de Mejora Regulatoria de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Anteproyecto Interno del Consejo Municipal
                                        de Mejora Regulatoria de Nuevo Laredo, Tamaulipas</option>
                            
                            
                                    <option value="Reglamento Interior del Republicano Ayuntamiento de Nuevo Laredo, Tamaulipas"
                                        style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                        Reglamento Interior del Republicano Ayuntamiento de Nuevo Laredo, Tamaulipas</option>

                                        <option value="Anteproyecto del Reglamento
                    Interior
                    de la Secretaria de Desarrollo Economico"
                                            style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                            Anteproyecto del Reglamento
                                            Interior
                                            de la Secretaría de Desarrollo Económico</option>
                            
                                -->
                                            <!--
                                </select>
                                <br>
                            
                                <small style="color:gray">{{displayTitulo}}</small>
                                <br>-->
                                <!--   <div class="mb-3 text-left">
                                                
                                                        <a *ngIf="cambia" href="https://nld.gob.mx/assets/reglamentos/{{displayTitulo}}/file1.pdf" target="_new"
                                                            style="color:#a19249">Abrir Anteproyecto</a>
                                                        <br>
                                                        <a *ngIf="twofiles" href="https://nld.gob.mx/assets/reglamentos/{{displayTitulo}}/file2.pdf" target="_new"
                                                            style="color:#a19249">Abrir Reglamento</a>
                                                    </div>-->
                            </div>
                            <!--                            <div class="mb-3 text-left">
                                <label class="form-label" class="">Email</label>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                    [(ngModel)]="email">
                               
                            </div>
                            <div class="mb-3 text-left">
                                <label class="form-label" class="">Teléfono</label>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                    [(ngModel)]="telefono">
                               
                            </div>
                            <div class="mb-3 text-left">
                                <label class="form-label" class="">Comentarios</label>
                                <textarea style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text" class="form-control"
                                    [(ngModel)]="comentarios" rows="3"></textarea>
                               
                            </div>
                            <ngx-recaptcha2 ngModel name="captcha" [siteKey]="siteKey" (success)="handleSuccess($event)" [useGlobalDomain]="false"
                                 (expire)="handleExpire($event)">
                            </ngx-recaptcha2>
                            <button *ngIf="captcha"  class="btn btn-primary pull-right" type="button" (click)="enviar()"> <span> <i
                                        class="bi bi-search"></i> Enviar</span>
                            </button>-->
                        </div>
                
                    </div>
                  
                   
                </div>
        </div>
    </div>
</div>
